module.exports = {
  aboutEg: {
    'zh-CN': '关于Enjoy Game',
    'zh-TW': '關於Enjoy Game',
    'en-US': 'About EnjoyGame',
    'th-TH': 'เกี่ยวกับ Enjoy Game',
    'vi-VN': 'About EnjoyGame'
  },
  aboutEgP1: {
    'zh-CN': 'Enjoy Game成立于2015年，核心成员均有八年以上行业经验，公司致力于将中国精品手机游戏发行到海外全球市场，以专业谋求更快速发展，以实力打造更优质精品，形成了独有的行业品牌和口碑。',
    'zh-TW': 'Enjoy Game 遊戲成立於2015年，核心成員均有八年以上行業經驗，公司致力於將中國精品手機遊戲發行到海外全球市場，以專業謀求更快速發展，以實力打造更優質精品，形成了獨有的行業品牌和口碑。',
    'en-US': 'Enjoy Game was established in 2015. The core members have more than 8 years of professional experience. The company is committed to distribute Chinese boutique mobile games to overseas markets. With several boutique products distributed, we already own a unique brand and reputation. And we are seeking for faster development with our professional ability!',
    'th-TH': 'ค่าย Enjoy Game ก่อตั้งขึ้นในปี 2015 พนักงานหลักต่างก็มีประสบการณ์มากกว่า 8 ปี เป็นบริษัทที่ให้บริการเกมส์มือถือทั่วโลก เราใส่ใจในคุณภาพของเกมส์เป็นที่สุด จึงกลายเป็นหนึ่งในบริษัทเกมส์ที่มีชื่อเสียง',
    'vi-VN': 'Enjoy Game was established in 2015. The core members have more than 8 years of professional experience. The company is committed to distribute Chinese boutique mobile games to overseas markets. With several boutique products distributed, we already own a unique brand and reputation. And we are seeking for faster development with our professional ability!'
  },
  aboutEgP2: {
    'zh-CN': '2015年到2016年上半年,Enjoy Game主攻港澳台、东南亚市场,2016年Q2开始开拓全球多语言市场, 均取得显著成功, 所发行的《天堂战记 Lineage War》《梦幻神域》等游戏,多次被谷歌苹果推荐,均 最高取得下载TOP1-3,畅销TOP1-5 的成绩。',
    'zh-TW': '2015年到2016年上半年，Enjoy Game主攻港澳台、東南亞市場，2016年Q2開始開拓全球多語言市場，均取得顯著成功，所發行的《Paradise War》《Sword of Fantasy》等遊戲，多次被谷歌蘋果推薦，均 最高取得下載TOP1-3，暢銷TOP1-5 的成績。',
    'en-US': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.',
    'th-TH': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.',
    'vi-VN': 'From 2015 to the first six months of 2016, EnjoyGame aimed specially at the markets of Hong Kong, Macao and Southeast Asia. Now, we have begun to develop the global multi-lingual market and have achieved remarkable success. Our games "Paradise War" and "Sword of Fantasy" have been featured repeatedly by Google Play and App Store, with Top Download rank 1-3, and Top Grossing rank1-5.'
  },
  brandAdvantage: {
    'zh-CN': '品牌优势',
    'zh-TW': '品牌優勢',
    'en-US': 'Our Advantages',
    'th-TH': 'Our Advantages',
    'vi-VN': 'Our Advantages'
  },
  operationTitle: {
    'zh-CN': '卓越的运营能力',
    'zh-TW': '卓越的運營能力',
    'en-US': 'Excellent operation capacity',
    'th-TH': 'Excellent operation capacity',
    'vi-VN': 'Excellent operation capacity'
  },
  operationItem1: {
    'zh-CN': '产品识别能力',
    'zh-TW': '產品識別能力',
    'en-US': 'Product identification capability',
    'th-TH': 'Product identification capability',
    'vi-VN': 'Product identification capability'
  },
  operationItem2: {
    'zh-CN': '产品调优能力',
    'zh-TW': '產品調優能力',
    'en-US': 'Product optimization capability',
    'th-TH': 'Product optimization capability',
    'vi-VN': 'Product optimization capability'
  },
  operationItem3: {
    'zh-CN': '持续运营能力',
    'zh-TW': '持續運營能力',
    'en-US': 'Continuous operation capacity',
    'th-TH': 'Continuous operation capacity',
    'vi-VN': 'Continuous operation capacity'
  },
  saleTitle: {
    'zh-CN': '领先的营销能力',
    'zh-TW': '領先的營銷能力',
    'en-US': 'Leading marketing capability',
    'th-TH': 'Leading marketing capability',
    'vi-VN': 'Leading marketing capability'
  },
  saleItem1: {
    'zh-CN': '全球采量能力',
    'zh-TW': '全球採量能力',
    'en-US': 'Attracting global players capacity',
    'th-TH': 'Attracting global players capacity',
    'vi-VN': 'Attracting global players capacity'
  },
  saleItem2: {
    'zh-CN': '持续优化能力',
    'zh-TW': '持續優化能力',
    'en-US': 'Continuous optimization capability',
    'th-TH': 'Continuous optimization capability',
    'vi-VN': 'Continuous optimization capability'
  },
  saleItem3: {
    'zh-CN': '全面包装能力',
    'zh-TW': '全面包裝能力',
    'en-US': 'Global package capacity',
    'th-TH': 'Global package capacity',
    'vi-VN': 'Global package capacity'
  },
  techTitle: {
    'zh-CN': '强大的技术支持',
    'zh-TW': '強大的技術支持',
    'en-US': 'Powerful technical support',
    'th-TH': 'Powerful technical support',
    'vi-VN': 'Powerful technical support'
  },
  techItem1: {
    'zh-CN': '快速的对接流程',
    'zh-TW': '快速的對接流程',
    'en-US': 'Fast docking process',
    'th-TH': 'Fast docking process',
    'vi-VN': 'Fast docking process'
  },
  techItem2: {
    'zh-CN': '强大的数据分析能力',
    'zh-TW': '強大的數據分析能力',
    'en-US': 'Powerful data analysis capability',
    'th-TH': 'Powerful data analysis capability',
    'vi-VN': 'Powerful data analysis capability'
  },
  techItem3: {
    'zh-CN': '高度定制化的数据采集能力',
    'zh-TW': '高度定制化的數據採集能力',
    'en-US': 'Highly customizable data acquisition capability',
    'th-TH': 'Highly customizable data acquisition capability',
    'vi-VN': 'Highly customizable data acquisition capability'
  },
  history: {
    'zh-CN': '发展历程',
    'zh-TW': '發展歷程',
    'en-US': 'Development',
    'th-TH': 'กระบวนการพัฒนา',
    'vi-VN': 'Development'
  },
  history201801: {
    'zh-CN': '《诺文尼亚》繁体版知名CV杉山纪章、柿原徹也强势助力献声，上线当周风靡台港澳地区，数十几媒体联袂推荐。',
    'zh-TW': '2018/01《諾文尼亞》繁體版知名CV杉山紀章，柿原徹也強勢助力獻聲，上線當周風靡台港澳地區，數十幾媒體聯袂推薦。',
    'en-US': 'Novenia-The famous CVs Sugiyama Noriaki and Kakihara Tetsuya of traditional version dedicate their beautiful voices. Once online, it went popular within one week in Taiwan, Hong Kong and Macao and was recommended by dozens of media.',
    'th-TH': '《Novenia》ฉบับจีนตัวเต็มพากย์โดย CVที่มีชื่อสียง Sugiyama NoriakiและKakihara Tetsuya ในสัปดาห์ที่เปิดOBTนั้น ก็ได้รับความนิยมในฮ่องกง มาเก๊าและไต้หวัน และได้รับคำแนะนำจากสื่อหลายสิบแห่ง',
    'vi-VN': 'Novenia-The famous CVs Sugiyama Noriaki and Kakihara Tetsuya of traditional version dedicate their beautiful voices. Once online, it went popular within one week in Taiwan, Hong Kong and Macao and was recommended by dozens of media.'
  },
  history201711: {
    'zh-CN': '《Luna  M》港澳台地区重磅上线，荣获双端商店推荐，韩国端游IP正版授权，100%极致还原Luna经典，玩家好评如潮。',
    'zh-TW': '《Luna M》港澳台地區重磅上線，榮獲雙端商店推薦，韓國端遊IP正版授權，100％極致還原Luna經典，玩家好評如潮。',
    'en-US': 'Luna M-Launched in Taiwan, Hong Kong and Macao, it was featured by both Google Play Store and App Store. With the authentic IP of the original Korean console game, it restored 100% the classical Luna and won great reputation from players.',
    'th-TH': '《Luna  M》เปิดOBTในฮ่องกง มาเก๊าและไต้หวัน  ได้รับคำแนะนำจากApplestoreและGoogleplay เกมนี้ได้รับอนุญาตอย่างเป็นทางการจากLUNA Online และได้รักษาความคลาสสิคของตัวเกมไว้อย่างครบถ้วน ได้รับความนิยมจากผู้เล่นเป็นอย่างมาก',
    'vi-VN': 'Luna M-Launched in Taiwan, Hong Kong and Macao, it was featured by both Google Play Store and App Store. With the authentic IP of the original Korean console game, it restored 100% the classical Luna and won great reputation from players.'
  },
  history201709: {
    'zh-CN': '《Dynasty Legends-ไทย》泰国火热上线，Boy_pakorn、Punpun_sutatta现场热力助阵，Arisara Karbdecho倾情代言！',
    'zh-TW': '《Dynasty Legends-ไทย》泰國火熱上線，Boy_pakorn，Punpun_sutatta現場熱力助陣，Arisara Karbdecho傾情代言！',
    'en-US': 'Dynasty Legends-ไทย-Hot online in Thailand! Boy Pakorn and Punpun Sutatta gave their strong support on the live show. And Arisara Karbdecho acted as the endorser!',
    'th-TH': '《Dynasty Legends-ไทย》เปิดOBTในประเทศไทย Boy_pakorn、Punpun_sutattaมาช่วยพลังใจให้ และมีArisara Karbdechoมาเป็นพรีเซนเตอร์ด้วย',
    'vi-VN': 'Dynasty Legends-ไทย-Hot online in Thailand! Boy Pakorn and Punpun Sutatta gave their strong support on the live show. And Arisara Karbdecho acted as the endorser!'
  },
  history201708: {
    'zh-CN': '《극무쌍》韩国，核心战斗割草的极致体验得到了玩家大力的称赞。',
    'zh-TW': '《극무쌍》韓國，核心戰鬥割草的極致體驗得到了玩家大力的稱讚。',
    'en-US': '극무쌍-Online in Korea, its ultimate combat experience won great praises from players.',
    'th-TH': '《극무쌍》วิธีการเล่นต่อสู้ได้รับความชื่นชมจากผู้เล่นของประเทศเกาหลีใต้',
    'vi-VN': '극무쌍-Online in Korea, its ultimate combat experience won great praises from players.'
  },
  history201707: {
    'zh-CN': '《Dynasty Legends》东南亚英文版燃情来袭，真3D三国动作手游！',
    'zh-TW': '《Dynasty Legends》東南亞英文版燃情來襲，真3D三國動作手游！',
    'en-US': 'Dynasty Legends-Southeast Asia English version struck. Real 3D action game of the Three Kingdoms!',
    'th-TH': '《Dynasty Legends》ฉบับอังกฤษเปิดOBTในเอเชียตะวันออกเฉียงใต้ เป็นเกมแอ็กชันสามก๊ก 3D',
    'vi-VN': 'Dynasty Legends-Southeast Asia English version struck. Real 3D action game of the Three Kingdoms!'
  },
  history201705: {
    'zh-CN': '《崩坏3rd》繁体版与米哈游联合发行台港澳地区，点燃ACG动作之魂，为世界上所有的美好而战！',
    'zh-TW': '《崩壞3rd》繁體版與米哈遊聯合發行台港澳地區，點燃ACG動作之魂，為世界上所有的美好而戰！',
    'en-US': ' Honkai Impact 3 -Traditional version. Cooperated with miHoYo, we distributed it in Taiwan, Hong Kong and Macao. Ignite the soul of ACG action, fight for all the goodness in the world!',
    'th-TH': '《Honkai Impact》ฉบับจีนตัวเต็มเปิดOBTร่วมมือกับบริษัท miHoYoอยู่ในฮ่องกง มาเก๊าและไต้หวัน เกมACG ต่อสู้เพื่อความสวยงามของโลก！',
    'vi-VN': ' Honkai Impact 3 -Traditional version. Cooperated with miHoYo, we distributed it in Taiwan, Hong Kong and Macao. Ignite the soul of ACG action, fight for all the goodness in the world!'
  },
  history201703: {
    'zh-CN': '《极无双》一周内跻身台港双榜畅销前十，双端商店连续两周推荐，深受动作类玩家喜爱。',
    'zh-TW': '《極無雙》一周內躋身台港雙榜暢銷前十，雙端商店連續兩週推薦，深受動作類玩家喜愛。',
    'en-US': 'Dynasty Legends-Classed in the top ten in Grossing Chart within one week. Featured for two weeks by both Google Play Store and App Store. Action players’ favorite!',
    'th-TH': '《Dynasty Legends》หลังจากเปิดOBTหนึ่งสัปดาห์ ฉบับจีนตัวเต็มเข้าชิงรายการที่ขายดีที่สุดของฮ่องกงและไต้หวัน ได้รับคำแนะนำจากApplestoreและGoogleplayต่อเนื่องสองอาทิตย์ ได้รับความนิยมจากผู้เล่นเป็นอย่างมาก',
    'vi-VN': 'Dynasty Legends-Classed in the top ten in Grossing Chart within one week. Featured for two weeks by both Google Play Store and App Store. Action players’ favorite!'
  },
  history201702: {
    'zh-CN': '《巴哈姆特之魂》台湾IOS强势登榜，总榜下载前五，畅销十五！',
    'zh-TW': '《巴哈姆特之魂》台灣IOS強勢登榜，總榜下載前五，暢銷十五！',
    'en-US': '《巴哈姆特之魂》台湾IOS强势登榜，总榜下载前五，畅销十五！',
    'th-TH': '《巴哈姆特之魂》台湾IOS强势登榜，总榜下载前五，畅销十五！',
    'vi-VN': '《巴哈姆特之魂》台湾IOS强势登榜，总榜下载前五，畅销十五！'
  },
  history201612: {
    'zh-CN': '《Paradise War》获“谷歌最具竞争力游戏”奖项',
    'zh-TW': '《Paradise War》獲“谷歌最具競爭力遊戲”獎項',
    'en-US': '《Paradise War》获“谷歌最具竞争力游戏”奖项',
    'th-TH': '《Paradise War》获“谷歌最具竞争力游戏”奖项',
    'vi-VN': '《Paradise War》获“谷歌最具竞争力游戏”奖项'
  },
  history201610: {
    'zh-CN': '《エレメンタル ファンタジー》日本双榜下载前十，畅销前百',
    'zh-TW': '《エレメンタル ファンタジー》日本雙榜下載前十，暢銷前百',
    'en-US': '《エレメンタル ファンタジー》日本双榜下载前十，畅销前百',
    'th-TH': '《エレメンタル ファンタジー》日本双榜下载前十，畅销前百',
    'vi-VN': '《エレメンタル ファンタジー》日本双榜下载前十，畅销前百'
  },
  history201605: {
    'zh-CN': '《Paradise War》上线全球，亚洲、欧洲多国下载畅销稳居前十',
    'zh-TW': '《Paradise War》上線全球，亞洲、歐洲多國下載暢銷穩居前十',
    'en-US': '《Paradise War》上线全球，亚洲、欧洲多国下载畅销稳居前十',
    'th-TH': '《Paradise War》上线全球，亚洲、欧洲多国下载畅销稳居前十',
    'vi-VN': '《Paradise War》上线全球，亚洲、欧洲多国下载畅销稳居前十'
  },
  history201603: {
    'zh-CN': '月流水破千万',
    'zh-TW': '月流水破千萬',
    'en-US': '月流水破千万',
    'th-TH': '月流水破千万',
    'vi-VN': '月流水破千万'
  },
  history201602: {
    'zh-CN': '《天域战记》台湾IOS创佳绩，下载畅销双榜前三！',
    'zh-TW': '《天域戰記》台灣IOS創佳績，下載暢銷雙榜前三！',
    'en-US': '《天域战记》台湾IOS创佳绩，下载畅销双榜前三！',
    'th-TH': '《天域战记》台湾IOS创佳绩，下载畅销双榜前三！',
    'vi-VN': '《天域战记》台湾IOS创佳绩，下载畅销双榜前三！'
  },
  history201601: {
    'zh-CN': '《天域战记》台湾地区谷歌商店总榜下载第一，畅销第八！',
    'zh-TW': '《天域戰記》台灣地區谷歌商店總榜下載第一，暢銷第八！',
    'en-US': '《天域战记》台湾地区谷歌商店总榜下载第一，畅销第八！',
    'th-TH': '《天域战记》台湾地区谷歌商店总榜下载第一，畅销第八！',
    'vi-VN': '《天域战记》台湾地区谷歌商店总榜下载第一，畅销第八！'
  },
  history201511: {
    'zh-CN': '《梦幻神域》上线东南亚，月流水破百万',
    'zh-TW': '《夢幻神域》上線東南亞，月流水破百萬',
    'en-US': '《梦幻神域》上线东南亚，月流水破百万',
    'th-TH': '《梦幻神域》上线东南亚，月流水破百万',
    'vi-VN': '《梦幻神域》上线东南亚，月流水破百万'
  },
  history201502: {
    'zh-CN': 'EnjoyGame成立',
    'zh-TW': 'EnjoyGame成立',
    'en-US': 'EnjoyGame成立',
    'th-TH': 'EnjoyGame成立',
    'vi-VN': 'EnjoyGame成立'
  },
  haveGoodGame: {
    'zh-CN': '有好的游戏产品？',
    'zh-TW': '有好的遊戲產品？',
    'en-US': 'Have good game products?',
    'th-TH': 'Have good game products?',
    'vi-VN': 'Have good game products?'
  },
  gotToSubmit: {
    'zh-CN': '前往提交',
    'zh-TW': '前往提交',
    'en-US': 'Go to submit',
    'th-TH': 'Go to submit',
    'vi-VN': 'Go to submit',
  }
};



// WEBPACK FOOTER //
// ./src/lang/about.js